declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

let initialized = false

export function initMetaPixel() {
  if (initialized) return
  initialized = true

  try {
    // Set up fbq queue function
    if (!window.fbq) {
      const n: any = (window.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      })
      window._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
    }

    // Load the FB pixel script
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)

    // Init and fire PageView
    window.fbq('init', '3055721534817207')
    window.fbq('track', 'PageView')

    // Also fire a fallback image pixel for PageView
    const img = document.createElement('img')
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.src =
      'https://www.facebook.com/tr?id=3055721534817207&ev=PageView&noscript=1'
    document.body.appendChild(img)
  } catch (e) {
    // Silently fail - don't break the page
    console.warn('Meta Pixel init failed:', e)
  }
}

export function trackAddToCart() {
  try {
    // Fire via fbq if available
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Stop Overpaying Medical Bills Blueprint',
        content_type: 'product',
        value: 6.39,
        currency: 'USD',
      })
    }

    // Also fire fallback image pixel for AddToCart
    const img = document.createElement('img')
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.src =
      'https://www.facebook.com/tr?id=3055721534817207&ev=AddToCart&noscript=1'
    document.body.appendChild(img)
  } catch (e) {
    console.warn('Meta Pixel AddToCart failed:', e)
  }
}
